import { FormStore, GlobalStore } from "@roc/feature-app-core";
import { DocumentStore } from "@roc/feature-documents";
import { LoanStore } from "@roc/feature-loans";
import { action, computed, flow, makeObservable, observable } from "mobx";
import { format } from "date-fns";
import { PayoffService } from "../services/payoffService";
import { downloadDocument } from "@roc/feature-utils";

const form = {
  fields: {
    loanId: {
      value: '',
      error: null,
      rule: '',
    },
    newLenderMERS: {
      value: false,
      error: null,
      rule: '',
    },
    oldLenderMERS: {
      value: false,
      error: null,
      rule: '',
    },
    newLenderName: {
      value: '',
      error: null,
      rule: '',
    },
    newLenderAddress: {
      value: '',
      error: null,
      rule: '',
    },
    oldLender: {
      value: '',
      error: null,
      rule: '',
    },
    buildingMortgage: {
      value: false,
      error: null,
      rule: '',
    },
    newLenderAttorney: {
      value: '',
      error: null,
      rule: '',
    },
    newLenderMortgageeClause: {
      value: '',
      error: null,
      rule: '',
    },
    recordedDate: {
      value: '',
      error: null,
      rule: '',
    },
    recordedDateBuilding: {
      value: '',
      error: null,
      rule: '',
    },
    recordedDocDate: {
      value: '',
      error: null,
      rule: '',
    },
    recordedCounty: {
      value: '',
      error: null,
      rule: '',
    },
    recordedDocInformation: {
      value: '',
      error: null,
      rule: '',
    },
    recordedDocInformationBuilding: {
      value: '',
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class GenerateCemaStore extends FormStore {

  private documentStore: DocumentStore;
  private globalStore: GlobalStore;
  loanStore: LoanStore;
  payoffService: PayoffService;
  loanId: string;
  generateDocumentsInProgress: boolean = false;

  constructor(
    loanStore: LoanStore,
    documentStore: DocumentStore,
    globalStore: GlobalStore
  ) {
    super({ ...form }, globalStore);
    this.documentStore = documentStore;
    this.globalStore = globalStore;
    this.loanStore = loanStore;
    this.payoffService = new PayoffService();

    makeObservable(this, {
      loanId: observable,
      setLoanId: action,
      generateCemaDocuments: flow,
      generateDocumentsInProgress: observable,
    });
  }

  initialize(loanId) {
    this.resetStore();
    this.onFieldChange('recordedDate', new Date());
    this.onFieldChange('recordedDateBuilding', new Date());
    this.onFieldChange('recordedDocDate', new Date());
    this.setLoanId(loanId);
  }

  setLoanId(loanId) {
    this.loanId = loanId;
    this.onFieldChange('loanId', loanId);
  }

  *generateCemaDocuments() {
    try {
      this.runFormValidationWithMessage();
      if (this.form.meta.isValid) {
        this.generateDocumentsInProgress = true;
        this.globalStore.notificationStore.showInfoNotification({
          message: 'Downloading CEMA documents. This may take a moment, please wait.',
        });
        const formValues = this.getFormValues();
        const request = {
          ...formValues,
          recordedDate: formValues.recordedDate ? format(new Date(formValues.recordedDate), 'MM/dd/yyyy') : '',
          recordedDateBuilding: formValues.recordedDateBuilding ? format(new Date(formValues.recordedDateBuilding), 'MM/dd/yyyy') : '',
          recordedDocDate: formValues.recordedDocDate ? format(new Date(formValues.recordedDocDate), 'MM/dd/yyyy') : '',
        }
        yield this.documentStore.documentFormStore.closeCurrentForm();
        const response = yield this.payoffService.downloadCemaDocs(request);
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'CEMA documents downloaded successfully.',
        });
        this.generateDocumentsInProgress = false;
        downloadDocument(response.data, response.headers, 'download', `${this.loanId} - Generated CEMA Docs.zip`);
      }
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an issue generating the CEMA documents. Please reach out to the tech team.',
      });
      this.generateDocumentsInProgress = false;
    }
  }

  resetStore() {
    this.reset();
    this.loanId = null;
  }
}

export default GenerateCemaStore;
